import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson2DefaultStartCode = `%lang starknet

// What is really neat with implicit arguments is that they are returned implicitly by any function using them
// This is a very powerful feature of the language since it helps with readability, letting the developer omit
// implicit arguments in the subsequent function calls.

// You change the function signature!
func black_box{secret : felt}() -> () {
    ${doNotModifyCodeAbove}`;

export const lesson2DefaultMiddleCode = `
    // TODO: implement the "black_box" function body to make the test pass

    return ();
}`;

export const lesson2DefaultEndCode = `${doNotModifyCodeBelow}
@external
func test_secret_change{syscall_ptr : felt*}() {
    let secret = 'no so secret';
    with secret {
        black_box();
        assert secret = 'very secret!';
    }

    return ();
}`;
